const COLUMNS_GROUPS = [
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "profilename",
    label: "PROFILE NAME",
    widget: "text",
    width: 220
  },
  {
    id: "frequency",
    label: "FREQUENCY",
    widget: "text",
    width: 200
  },
  {
    id: "lastinvoicedate",
    label: "LAST INVOICE DATE",
    widget: "text",
    width: 180
  },
  {
    id: "nextinvoicedate",
    label: "NEXT INVOICE DATE",
    widget: "text",
    width: 180
  },
  {
    id: "status",
    label: "STATUS",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  }
];


const ROW_DATA = [
  {
    customername: "John Smith Customer",
    profilename: "Recurring Invoice 1",
    frequency: "Due on Receipt",
    lastinvoicedate: "15 Jun 2025",
    nextinvoicedate: "--",
    status: "STOPPED",
    amount: 600
  },
  {
    customername: "Emily Johnson Customer",
    profilename: "Recurring Invoice 2",
    frequency: "Net 60",
    lastinvoicedate: "15 Jun 2025",
    nextinvoicedate: "--",
    status: "STOPPED",
    amount: 6879
  },
  {
    customername: "David Williams Customer",
    profilename: "Recurring Invoice 3",
    frequency: "Due end of the month",
    lastinvoicedate: "15 Jun 2025",
    nextinvoicedate: "--",
    status: "STOPPED",
    amount: 9050
  }];

export {COLUMNS_GROUPS,ROW_DATA};